import React from "react"
import './styles.scss'

 class ScenarioEquilibrageGestionnaire extends React.Component {
    render() {
        return(
            <div className='main'>
            <h3 className='main-heading'><b>EQUILIBRAGE DU SCÉNARIO DE FONCTIONNEMENT (VUE GESTIONNAIRE)</b></h3>
            <div className='gestonnaire-page'>
            <table id="customers">
                    <tbody>
                        <tr>
                            <th>Numéro</th>
                            <th>Article</th>
                            <th style={{width:'11rem'}}>Gestionnaire <br />
                            <th style={{width:'11rem'}}>Objectifi:100000</th></th>
                            <th>-</th>
                        </tr>
                        <tr className='even'>
                            <td>Numéro</td>
                            <td>Article</td>
                            <td style={{width:'11rem'}}>Objectifi:100000</td>
                            <td>- €</td>
                        </tr>
                    </tbody>
            </table> 
            </div>          
            </div>
        )
    }
}

    export default ScenarioEquilibrageGestionnaire


// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario_equilibrage_gestionnaire.js